import { DocumentType } from './document-type';

export interface UnreadDocumentsCount {
  totalOffers: number;
  totalCommunications: number;
  counts: UnreadDocumentsCountsMap;
}

export const getTotalDocumentsCount = (
  unreadDocumentsCount: UnreadDocumentsCount
): number =>
  Object.values(unreadDocumentsCount.counts).reduce(
    (acc, item) => item + acc,
    0
  );
export type UnreadDocumentsCountsMap = { [Key in DocumentType]: number };
